import React, { useEffect, useState } from 'react';
import { DialogFrame } from '../../../core/DialogFrame';
import { IConfig } from '../../../../Interfaces/IConfig';
import { Step, StepLabel } from '@mui/material';
import { RestoreProgress } from '../RestoreProgress';
import { SaveProgress } from '../SaveProgress';
import { CustomeSlide } from '../../../core/CustomeSlide';
import Send from '../../../generic/Send';
import { IRelationshipLandRegisterQuery } from '../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { LegalTransactionRelationshipTypeEnum } from '../../../../Interfaces/ILegalTransactionRelationship/LegalTransactionRelationshipTypeEnum';
import { StartLandRegisterQuery } from './Childs/Dialog/StartLandRegisterQuery';
import { LandRegisterQueryOverview } from './Childs/Dialog/LandRegisterQueryOverview';
import { LandRegisterQueryDocuments } from './Childs/Dialog/LandRegisterQueryDocuments';
import { LandRegisterQuerySummary } from './Childs/Dialog/LandRegisterQuerySummary';
import { useNavigate } from 'react-router-dom';
import { ConfirmNavigateBackDialog } from '../../../core/ConfirmNavigateBackDialog';

interface IProps {
  configObject: IConfig;
}

export const LandRegisterQueryDialog: React.FC<IProps> = ({ configObject }) => {
  const navigate = useNavigate();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const [lastCurrentPage, setLastCurrentPage] = useState(-1);

  /* ###############################  BEGIN Browser-Action-Control: <- and -> ############################### */
  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      setConfirmDialogOpen(true);
      // neuen State pushen, damit die Pfeiltaste erneut funktioniert
      window.history.pushState(null, '', window.location.href);
    };

    // initialen State pushen
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const handleCancel = () => {
    setConfirmDialogOpen(false);
    window.history.pushState(null, '', window.location.href);
  };

  const handleConfirm = () => {
    setConfirmDialogOpen(false);
    navigate('/');
  };

  const [relationship, setRelationship] =
    useState<IRelationshipLandRegisterQuery>({
      Created: new Date(),
      DocumentArray: [],
      idLegalTransaction: -1,
      idRelationship: -1,
      idRelationshipType:
        LegalTransactionRelationshipTypeEnum.LandRegisterQuery,
      isActiveRelationship: true,
      isCompanyFormation: false,
      Members: [],
      PartnerIdentifiers: [],
      RealEstateArray: [],
      RelationshipType: 'Grundbuchauszug',
      syncWithArnoTop: false,
      Updated: new Date(),
      data: { ReasonLandRegisterQueryArray: [] },
    });

  const handleBack = () => {
    setLastCurrentPage(currentPage);
    setCurrentPage(currentPage - 1);
  };
  const handleNext = () => {
    setLastCurrentPage(currentPage);
    setCurrentPage(currentPage + 1);
  };

  return (
    <>
      <ConfirmNavigateBackDialog
        open={confirmDialogOpen}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
      />

      <DialogFrame
        configObject={configObject}
        title='Formular Kaufvertrag'
        currentPage={currentPage}
        stepperArray={[
          <Step key={`LandRegisterQueryDialog-0`} completed={currentPage > 0}>
            <StepLabel>Grundbuchauszug</StepLabel>
          </Step>,
          <Step key={`LandRegisterQueryDialog-1`} completed={currentPage > 1}>
            <StepLabel>Grundstücke</StepLabel>
          </Step>,
          <Step key={`LandRegisterQueryDialog-2`} completed={currentPage > 2}>
            <StepLabel>Dokumente</StepLabel>
          </Step>,
          <Step key={`LandRegisterQueryDialog-3`} completed={currentPage > 3}>
            <StepLabel>Zusammenfassung</StepLabel>
          </Step>,
        ]}
        headerButtonArray={[
          <RestoreProgress
            key='landregisterquery-import'
            setterFunction={() => {}}
          ></RestoreProgress>,
          <SaveProgress
            key='landregisterquery-export'
            idLegaltransaction={1}
            getDataToSave={() => {}}
            filename={'Kaufvertrag'}
          ></SaveProgress>,
        ]}
        txt={''}
      >
        <CustomeSlide
          currentPage={currentPage}
          pageNumber={0}
          lastCurrentPage={lastCurrentPage}
          appear={false}
        >
          <StartLandRegisterQuery
            handleBack={handleBack}
            handleNext={handleNext}
          />
        </CustomeSlide>

        <CustomeSlide
          currentPage={currentPage}
          pageNumber={1}
          lastCurrentPage={lastCurrentPage}
          appear={false}
        >
          <LandRegisterQueryOverview
            config={configObject}
            handleBack={handleBack}
            handleNext={handleNext}
            relationship={relationship}
            setRelationsship={setRelationship}
          />
        </CustomeSlide>

        <CustomeSlide
          currentPage={currentPage}
          pageNumber={2}
          lastCurrentPage={lastCurrentPage}
          appear={false}
        >
          <LandRegisterQueryDocuments
            relationship={relationship}
            setRelationsship={setRelationship}
            handleBack={handleBack}
            handleNext={handleNext}
          />
        </CustomeSlide>

        <CustomeSlide
          currentPage={currentPage}
          pageNumber={3}
          lastCurrentPage={lastCurrentPage}
          appear={false}
        >
          <LandRegisterQuerySummary
            configObject={configObject}
            relationship={relationship}
            handleBack={handleBack}
            handleNext={handleNext}
          />
        </CustomeSlide>

        <CustomeSlide
          currentPage={currentPage}
          pageNumber={4}
          lastCurrentPage={lastCurrentPage}
        >
          <Send />
        </CustomeSlide>
      </DialogFrame>
    </>
  );
};
